import { BlocksIconHealth } from 'blocks-nextjs/blocks-web-components/components/icon/icons/health';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconHealth = createComponent({ react: React, tagName: 'cat-icon-health', elementClass: BlocksIconHealth });
